import { useState } from 'react';
import { SelectionInfo } from 'dragonmouse-shared/devigner';
import { Frame } from 'dragonmouse-shared/interfaces';
import { trackVisualEditAction } from 'analytics';
import Icon, { IconType } from 'components/Icon';
import eventManager from 'events/EventManager';
import * as S from './styles';

interface TextEditControlProps {
	frame: Frame;
	selectionInfo: SelectionInfo;
}

// Number of text rows shown by default. Containers with rich content (a
// long-form article, say) can have 20+ text descendants — without a cap the
// Text section dominates the panel and pushes Style/Comments off-screen.
const INITIAL_VISIBLE = 5;

// Truncate text content for the row preview so a long paragraph doesn't blow
// out the panel width. Full text is addressable by clicking through.
const truncate = (s: string, n: number): string => (s.length > n ? s.slice(0, n - 1) + '…' : s);

const TextEditControl = ({ frame, selectionInfo }: TextEditControlProps) => {
	const [showAll, setShowAll] = useState(false);

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------

	const onEdit = (elementId: string) => {
		trackVisualEditAction('edit_text_via_panel');
		eventManager.emit('enter-text-edit', { frameId: frame.id, elementId });
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	const textNodes = selectionInfo.textNodes;
	if (!textNodes || textNodes.length === 0) return null;

	const visibleNodes = showAll ? textNodes : textNodes.slice(0, INITIAL_VISIBLE);
	const hiddenCount = textNodes.length - visibleNodes.length;

	return (
		<S.Base>
			{visibleNodes.map((node, i) => (
				<S.Row key={`${node.elementId}-${i}`} onClick={() => onEdit(node.elementId)}>
					<S.RowText>{truncate(node.content, 40)}</S.RowText>
					<S.HoverOverlay>
						<Icon type={IconType.LINE_ARROW_LEFT} width={14} height={14} />
						Edit in prototype
					</S.HoverOverlay>
				</S.Row>
			))}
			{hiddenCount > 0 && (
				<S.ShowAllButton onClick={() => setShowAll(true)}>
					Show all ({textNodes.length})
				</S.ShowAllButton>
			)}
		</S.Base>
	);
};

export default TextEditControl;
